export const link = (url, blank=true) => {
  if (blank) {
    const win = window.open(url, '_blank');
    win.focus()
  }
  else {
    window.location.href = url;
  }

}